export const errorMessage = {
    somethingWentWrong: 'Something went wrong, Please try again!',
    invalidPartner: 'Invalid Partner, Please Enter a Valid Partner URL!',
    invalidFacility: 'Unabled to Fetch Faclity , Please Try Again!',
    notFound: 'PAGE NOT FOUND',
    facilityChange: 'The rate for this permit might be revised from the next cycle in case of any change in Driver License number.',
    customer_banner_heading: 'Wailuku Town Parking Permits',
    customer_banner_text: 'Welcome to the Wailuku Town Parking Permit Portal! Designed exclusively for Wailuku Town, this program offers an alternative monthly parking solution.'
}